export type Commission = {
  name: string
  manager: string
  members?: string[]
  children?: Commission[]
  superName?: string
  info?: string
  mail?: string
}

const data: Commission[] = [
  {
    name: "Arbitres",
    manager: "Nadège DELZONGLE (PCRA)",
    members: [
      "Lucie BALAZOT (adj. Lorraine)",
      "Tatiana MOYSES (adj. Alsace)",
    ],
    mail: "com.arbitres@tiralarc-grand-est.fr",
  },
  {
    name: "Calendrier",
    manager: "Nadège DELZONGLE",
    members: [
      "Lucie BALAZOT",
    ],
    mail: "com.calendrier@tiralarc-grand-est.fr",
  },
  {
    name: "Communication",
    manager: "Guy STRAUMANN",
    members: [
      "Hervé PACIEL",
      "Camille WILLEM-HOELLINGER",
    ],
    mail: "com.communication@tiralarc-grand-est.fr",
  },
  {
    name: "Formation",
    manager: "Jean-Pierre HERVIEU-BERGERON",
    members: ["Lucie BALAZOT"],
    mail: "com.formation@tiralarc-grand-est.fr",
  },
  {
    name: "Labels",
    manager: "Gérard BRISSAUD",
    members: ["Jean-Pierre HERVIEU-BERGERON"],
    info: "1 référent par département",
    mail: "com.labellisation@tiralarc-grand-est.fr",
  },
  {
    name: "Licences",
    manager: "Nadège DELZONGLE",
    mail: "com.licences@tiralarc-grand-est.fr",
  },
  {
    name: "Médicale",
    manager: "Hélène DELMOTTE",
    mail: "com.medicale@tiralarc-grand-est.fr",
  },
  {
    name: "Sport/Santé",
    manager: "Roland LANGAS",
    mail: "com.sportive@tiralarc-grand-est.fr",
  },
  {
    name: "Commission sportive",
    manager: "Jean-Bernard DUVAL",
    superName: "Sous-commissions",
    mail: "com.sportive@tiralarc-grand-est.fr",
    children: [
      {
        name: "Adultes",
        manager: "Hervé PACIEL",
        info: "Salle, TAE, DR",
        members: ["Jacky SOUDANT"],
        mail: "com.sportive.adultes@tiralarc-grand-est.fr",
      },
      {
        name: "Jeunes",
        manager: "Camille WILLEM-HOELLINGER",
        mail: "com.sportive.jeunes@tiralarc-grand-est.fr",
      },
      {
        name: "Parcours",
        manager: "Tatiana MOYSES",
        info: "Campagne, 3D, Nature",
        members: ["Roland LANGAS"],
        mail: "com.sportive.parcours@tiralarc-grand-est.fr",
      },
      {
        name: "Para tir à l'arc",
        manager: "Jocelyne PETIT",
        info: "FFH et FFSA",
        mail: "com.sportive.para@tiralarc-grand-est.fr",
      },
      {
        name: "Traditions",
        manager: "Jacky SOUDANT",
        info: "Beursault, Bouquet Provincial",
        mail: "com.sportive.traditions@tiralarc-grand-est.fr",
      },
      {
        name: "UNSS",
        manager: "Jean-Bernard DUVAL",
        mail: "com.sportive@tiralarc-grand-est.fr",
      },
    ],
  },
]

export default data
